import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const BannerButton = ({
  children,
  'data-test-id': dataTestId,
  onClick,
  use
}) => /*#__PURE__*/_jsx(Button, {
  "data-test-id": dataTestId,
  marginInlineStart: "400",
  onClick: onClick,
  size: "extra-small",
  use: use,
  children: children
});
BannerButton.displayName = 'BannerButton';
export default BannerButton;